import { reviewProposedTimeLinkText, editEventLinkText } from './EditEventLink.locstring.json';
import loc from 'owa-localize';
import generatePartialEventForProposeNewTime from '../utils/generatePartialEventForProposeNewTime';
import getCalendarDeepLinkUrl from '../utils/getCalendarDeepLinkUrl';
import { default as logMeetingMessageAction } from '../utils/logMeetingMessageAction';
import MeetingMessageActionEntrySource from '../store/schema/MeetingMessageActionEntrySource';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { isFeatureEnabled } from 'owa-feature-flags';
import { popoutCalendarComposeWithItemId } from 'owa-popout-utils/lib/utils/popoutCalendarCompose';
import MeetingMessage from 'owa-service/lib/contract/MeetingMessage';
import MeetingResponseMessage from 'owa-service/lib/contract/MeetingResponseMessageType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

import * as React from 'react';

const styles = require('./MeetingResponseInfo.scss');
const classNames = require('classnames/bind').bind(styles);

export interface EditEventLinkProps {
    item: MeetingResponseMessage;
    entrySource: MeetingMessageActionEntrySource;
    editLinkClassName?: string;
    editLinkText?: string;
}

const EditEventLink = (props: EditEventLinkProps) => {
    const { item, editLinkClassName, editLinkText } = props;

    // If there is no calendar item created yet, or if the user is not the organizer of the calendar item
    if (!item.AssociatedCalendarItemId || !(item as MeetingMessage).IsOrganizer) {
        return null;
    }

    function onClick() {
        logMeetingMessageAction('ReviewPNT', item, props.entrySource);
        popoutCalendarComposeWithItemId(
            item.AssociatedCalendarItemId,
            partialEvent,
            'Mail_AcceptPNT'
        );
    }

    // Generate the partial event which contains proposed time and attendee information
    const partialEvent = item.ProposedStart ? generatePartialEventForProposeNewTime(item) : null;

    const editLinkStyles = classNames(styles.editLink, editLinkClassName);

    const linkElement = isReactCalendarEnabled() ? (
        <Link className={editLinkStyles} onClick={onClick}>
            {editLinkText || loc(reviewProposedTimeLinkText)}
        </Link>
    ) : (
        <Link
            className={editLinkStyles}
            href={getCalendarDeepLinkUrl(item.AssociatedCalendarItemId.Id, true /* isEdit */)}
            target={item.AssociatedCalendarItemId.Id}>
            {editLinkText || loc(editEventLinkText)}
        </Link>
    );

    return <div className={styles.editLinkContainer}>{linkElement}</div>;
};

function isReactCalendarEnabled(): boolean {
    const userOptions = getUserConfiguration().UserOptions;
    return (
        isFeatureEnabled('cal-react') ||
        (userOptions &&
            userOptions.ReactOptinSettings &&
            userOptions.ReactOptinSettings.CalendarEnabled)
    );
}

export default EditEventLink;
